<h2 class="conferma__titolo" mat-dialog-title>
  @if (dati.distruttiva) {
    <mat-icon class="conferma__segno" aria-hidden="true">warning_amber</mat-icon>
  }
  {{ dati.titolo }}
</h2>

@if (dati.testo) {
  <mat-dialog-content>
    <p class="conferma__testo">{{ dati.testo }}</p>
  </mat-dialog-content>
}

<mat-dialog-actions align="end">
  <button type="button" mat-button (click)="chiudi(false)">{{ dati.annulla ?? 'Annulla' }}</button>
  @if (dati.distruttiva) {
    <button type="button" mat-stroked-button class="conferma__procedi--distruttiva" (click)="chiudi(true)">
      {{ dati.conferma ?? 'Procedi' }}
    </button>
  } @else {
    <button type="button" mat-flat-button color="primary" (click)="chiudi(true)">
      {{ dati.conferma ?? 'Procedi' }}
    </button>
  }
</mat-dialog-actions>
